export default "__VITE_ASSET__f99e5c13__"